<script>
import debounce from "lodash-es/debounce";

export default {
  props: {
    placeholder: { default: "" },
    cropper: { default: null }
  },

  data() {
    return {
      inputFile: null,
      filename: null,
      objectUrl: null,
      croppedImage: null,
      cropperInstance: null,
      cropperOpened: false
    };
  },

  methods: {
    vueCropper() {
      return this.cropperInstance.__vue__;
    },

    initCrop(inputElement) {
      if (!["image/jpeg", "image/png"].includes(this.inputFile.type)) {
        alert("Dit is geen geldige afbeelding.");
        inputElement.value = null;
        return this.reset();
      }

      if (this.inputFile.size > 7 * 1024 * 1024) {
        alert("De afbeelding mag maximaal 7MB zijn.");
        inputElement.value = null;
        return this.reset();
      }

      const objectUrl = window.URL.createObjectURL(this.inputFile);

      var image = document.createElement("img");
      image.src = objectUrl;

      image.onerror = $event => {
        alert("Dit is geen geldige afbeelding.");
        inputElement.value = null;
        return this.reset();
      };

      image.onload = () => {
        const height = image.height;
        const width = image.width;

        if (!this.cropper.hideErrors) {
          if (this.cropper.minWidth > 0 && this.cropper.minWidth > width) {
            alert(
              "Deze afbeelding is niet breed genoeg. De minimale breedte is " +
                this.cropper.minWidth +
                " pixels."
            );

            inputElement.value = null;
            return this.reset();
          }

          if (this.cropper.minHeight > 0 && this.cropper.minHeight > height) {
            alert(
              "Deze afbeelding is niet hoog genoeg. De minimale hoogte is " +
                this.cropper.minHeight +
                " pixels."
            );

            inputElement.value = null;
            return this.reset();
          }
        }

        this.objectUrl = objectUrl;
      };
    },

    reset() {
      this.filename = this.cropperInstance = this.objectUrl = this.inputFile = this.croppedImage = null;
    }
  },

  render() {
    return this.$scopedSlots.default({
      filename: this.filename,
      objectUrl: this.objectUrl,
      cropperOpened: this.cropperOpened,
      croppedImage: this.croppedImage,
      placeholder: this.placeholder,

      setCropper: () => {
        this.cropperInstance = document.querySelector("#" + this.cropper.id);
        this.croppedImage = this.vueCropper()
          .getCroppedCanvas({
            fillColor: "#fff"
          })
          .toDataURL("image/jpeg", 0.5);
        this.cropperOpened = true;

        this.$nextTick(function() {
          var resizeEvent = window.document.createEvent("UIEvents");
          resizeEvent.initUIEvent("resize", true, false, window, 0);
          window.dispatchEvent(resizeEvent);

          this.vueCropper().zoomTo(0);

          window.addEventListener("resize", () => {
            if (this.cropperInstance) {
              this.vueCropper().zoomTo(0);
            }
          });
        });
      },

      onCrop: debounce($event => {
        if (!this.cropperInstance) {
          return;
        }

        var width = $event.detail.width;
        var height = $event.detail.height;

        if (width < this.cropper.minWidth || height < this.cropper.minHeight) {
          this.vueCropper().setData({
            width: this.cropper.minWidth,
            height: this.cropper.minHeight
          });
        }

        this.croppedImage = this.vueCropper()
          .getCroppedCanvas({
            fillColor: "#fff"
          })
          .toDataURL("image/jpeg", 0.5);
      }, 100),

      storeImage: () => {
        const hiddenInput = document.querySelector(
          'input[name="' + this.cropper.id + '"]'
        );

        let cropAttributes = {
          minWidth: this.cropper.minWidth,
          minHeight: this.cropper.minHeight,
          imageSmoothingEnabled: false,
          fillColor: "#fff"
        };

        if (this.cropper.maxWidth) {
          cropAttributes.maxWidth = this.cropper.maxWidth;
        }

        if (this.cropper.maxHeight) {
          cropAttributes.maxHeight = this.cropper.maxHeight;
        }

        hiddenInput.value = this.vueCropper()
          .getCroppedCanvas(cropAttributes)
          .toDataURL("image/jpeg", 0.9);

        this.cropperOpened = false;
        this.cropperInstance = null;
      },

      changed: e => {
        this.reset();

        this.$nextTick(function() {
          const filename = e.target.files.length
            ? e.target.files[0].name
            : null;

          if (filename && this.cropper) {
            this.inputFile = e.target.files[0];
            this.initCrop(e.target);
          }

          this.filename = filename;
        });
      }
    });
  }
};
</script>
